module.exports = __webpack_public_path__ + "static/media/GitHub.9d61b111.jpg";